import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import Global from '../../store/global-selectors';
import { InsuranceModal } from '../modals/insurance-modal';
import { useActiveFulfillmentForFulfillmentPlan } from '../../hooks/entities/selectors/fulfillments';
import { useFulfillmentPlannerContext } from '../../fulfillment-planner/context';
import { useGetFileAClaimDetails } from '../hooks/use-get-file-a-claim-details';
import { useModal } from '../../hooks/use-modal';

export const FileAClaimButton = ({ insuranceProviderName = 'None', fulfillmentPlanIdProp, children: renderButton }) => {
  const { fulfillmentPlanId } = useFulfillmentPlannerContext();
  const { close, isOpen, open } = useModal();

  const sellerId = useSelector((state) => Global.selectSellerSellerId(state)) ?? '';
  const fulfillment = useActiveFulfillmentForFulfillmentPlan(fulfillmentPlanIdProp || fulfillmentPlanId);
  const { insuranceBookingId, insuranceClaimInitiationUrl } = fulfillment ?? {};

  const { showFileAClaim, isParcelGuard, isXCover, isShipsurance, url } = useGetFileAClaimDetails(
    sellerId,
    insuranceBookingId,
    insuranceClaimInitiationUrl,
    insuranceProviderName,
  );

  return (
    <>
      {showFileAClaim && (isParcelGuard || isXCover) && renderButton({ open })}
      {showFileAClaim && isShipsurance && renderButton({ url })}
      {isOpen && (
        <InsuranceModal
          close={close}
          fulfillmentPlanId={fulfillmentPlanIdProp || fulfillmentPlanId}
          insuranceProviderName={insuranceProviderName}
          shipmentId={fulfillmentPlanIdProp || fulfillmentPlanId}
          url={url}
        />
      )}
    </>
  );
};

FileAClaimButton.propTypes = {
  insuranceProviderName: PropTypes.string,
  fulfillmentPlanIdProp: PropTypes.string,
  children: PropTypes.func.isRequired,
};
